import { Dict } from "./types";

export function omit<T extends object, K extends keyof T>(
  object: T,
  keys: K[]
): Omit<T, K> {
  const keySet = new Set(keys);
  return Object.keys(object).reduce((obj, key) => {
    if (!keySet.has(key as K)) {
      obj[key as K] = object[key as K];
    }
    return obj;
  }, {} as T);
}

export function pick<T extends Dict, K extends keyof T>(
  object: T | undefined,
  keys: K[]
) {
  // TODO handle invalid objects properly
  if (!object) {
    return {};
  }

  return Object.keys(object).reduce((obj, key) => {
    if (keys.includes(key as K))
      return {
        ...obj,
        [key]: object[key],
      };
    return { ...obj };
  }, {});
}
export function split<T extends Dict, K extends keyof T>(object: T, keys: K[]) {
  const picked = pick(object, keys);
  const omitted = omit(object, keys);

  return [picked, omitted] as [{ [P in K]: T[P] }, Omit<T, K>];
}

export function omitNullOrUndefined<T extends Dict>(object: T): Partial<T> {
  return Object.keys(object).reduce((obj, key) => {
    if (object[key] == null) {
      return { ...obj };
    }
    return {
      ...obj,
      [key]: object[key],
    };
  }, {});
}
